import { MsalAuthenticationResult } from "@azure/msal-react";

export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({
  error,
}) => {
  return (
    <div className="max-w-md mx-auto mt-8 bg-white rounded-xl border border-gray-200/70 shadow-card overflow-hidden">
      <div className="p-6">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0">
            <svg
              className="w-5 h-5 text-red-500"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
            </svg>
          </div>
          <div>
            <h3 className="text-gray-900 font-semibold">
              Authentication Error
            </h3>
            <p className="text-red-600 text-sm mt-1">
              {error ? error.errorCode : "An unknown error occurred"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
